import { Routes, Route, useLocation } from 'react-router-dom'
import { useWebAuthBootstrap } from './AppBootstrap'
import { useAppStore } from '@/store/useAppStore'
import { useCategories, useCards } from '@/hooks/useApi'
import LoadingScreen from '@/components/LoadingScreen/LoadingScreen'
import ScrollToTop from '@/components/ScrollToTop'
import Layout from '@/components/Layout/Layout'
import ProfilePage from '@/pages/ProfilePage/ProfilePage'
import CoursesPage from '@/pages/CoursesPage/CoursesPage'
import CourseDetailPage from '@/pages/CourseDetailPage/CourseDetailPage'
import LessonPage from '@/pages/LessonPage/LessonPage'
import AuthPage from '@pages/AuthPage/AuthPage'
import TermsPage from '@pages/TermsPage/TermsPage'
import PrivacyPage from '@pages/PrivacyPage/PrivacyPage'
import RefundPage from '@pages/RefundPage/RefundPage'
import { PaymentStatusModal } from '@features/payments'
import { ProtectedRoute } from './routes/ProtectedRoute'
import { PublicRoute } from './routes/PublicRoute'
import { WebBackButton } from '@/components/WebBackButton/WebBackButton'
import CookieConsent from '@/components/CookieConsent/CookieConsent'

/**
 * EU-сервис (магазин курсов). Карта роутов:
 *   /                                     — каталог курсов (главная)
 *   /courses/:courseId                    — лендинг/детальная курса
 *   /courses/:courseId/lesson/:lessonId   — урок
 *   /auth                                 — вход по email-коду
 *   /profile                              — кабинет (мои курсы)
 *   /terms, /privacy                      — юридика
 */
export const WebAppShell = () => {
  const { status } = useWebAuthBootstrap()
  const location = useLocation()
  const authStatus = useAppStore(s => s.authStatus)
  const isAuthComplete = authStatus === 'success'

  useCategories(isAuthComplete)
  useCards()

  if (status === 'pending') {
    return <LoadingScreen isLoading={true} />
  }

  const shouldApplySafeArea =
    !location.pathname.match(/^\/courses\/\d/) &&
    !location.pathname.startsWith('/auth')

  return (
    <div className={shouldApplySafeArea ? 'safe-area-inset' : ''}>
      <ScrollToTop />
      <WebBackButton />
      <Routes>
        <Route
          path="auth"
          element={
            <PublicRoute>
              <AuthPage />
            </PublicRoute>
          }
        />
        <Route path="terms" element={<TermsPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="refund" element={<RefundPage />} />
        {/* EU-сервис: без Telegram-слоя. Роут привязки TG сохранён закомментированным.
        <Route path="link-telegram/confirm" element={<LinkTelegramConfirmScreen />} /> */}

        <Route element={<ProtectedRoute />}>
          <Route path="courses/:courseId" element={<CourseDetailPage />} />
          <Route
            path="courses/:courseId/lesson/:lessonId"
            element={<LessonPage />}
          />
          <Route path="/" element={<Layout />}>
            <Route index element={<CoursesPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
        </Route>
      </Routes>
      <PaymentStatusModal />
      <CookieConsent />
    </div>
  )
}
